<template>
  <div class="centerBox">
    <div class="newsDetail centBoxIn">
      <div class="topBanner">
        <img class="newsDetailImg" src="../../common/images/news/newsDetail.png" alt />
        <div class="title">资讯动态</div>
      </div>
      <div class="newsDetailBox">
        <div class="content">
          <div class="backRow">
            <span class="backBtn" @click="$router.back()">
              <i class="el-icon-arrow-left" />
              返回
            </span>
          </div>
          <div class="articleTit">{{ articleObj.title }}</div>
          <div class="articleInfo">
            <div class="artiTime">发布时间：{{ articleObj.publish_time }}</div>
            <div class="artiOrg">文章来源：{{ articleObj.source }}</div>
          </div>
          <div class="articleCont" v-html="articleObj.content" />
          <div class="articleControl">
            <div class="preArticle" @click="changeArti(articleObj.pre.id)">
              上一篇：{{ articleObj.pre && articleObj.pre.title }}
            </div>
            <div class="nextArticle" @click="changeArti(articleObj.next.id)">
              下一篇：{{ articleObj.next && articleObj.next.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getArticle } from "@/api/news";

export default {
  name: "newsDetail",
  data() {
    return {
      articleObj: {
        title: "",
        publish_time: "",
        source: "",
        content: "",
        pre: {
          id: 0,
          title: "",
        },
        next: {
          id: 0,
          title: "",
        },
      },
    };
  },
  mounted() {
    this.getArticle(this.$route.query.id);
  },
  methods: {
    getArticle(id) {
      getArticle(id).then((res) => {
        if (res.code == 200) {
          this.articleObj = res.data;
          this.articleObj.publish_time = res.data.publish_time.split("T")[0];
        }
      });
    },
    changeArti(id) {
      if (!id) return this.$message.error("没有上一篇或下一篇");
      this.getArticle(id);
      window.scrollTo(0, 0);
    },
  },
  computed: {},
};
</script>

<style scoped>
.newsDetail {
  /* width: 100%; */
}
.newsDetail .topBanner {
  position: relative;
}
.newsDetail .topBanner .newsDetailImg {
  vertical-align: middle;
  width: 100%;
}
.newsDetail .topBanner .title {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  font-family: Alibaba PuHuiTi ExtraBold;
  font-weight: normal;
  font-size: 103px;
  color: #fff;
  width: 100%;
}

.newsDetailBox {
  width: 100%;
  padding-top: 60px;
  padding-bottom: 40px;
  background-color: #fff;
}
.newsDetailBox .content {
  width: var(--content-width);
  min-width: var(--content-min-width);
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}
.newsDetailBox .content .backRow {
  display: flex;
  justify-content: start;
}
.newsDetailBox .content .backBtn {
  cursor: pointer;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
  text-align: left;
}
.newsDetailBox .content .backBtn:hover {
  color: #398fff;
}
.content .articleTit {
  font-weight: 800;
  font-size: 44px;
  color: #1a1a1a;
  text-align: center;
  border-bottom: 1px solid #cccccc;
  padding-top: 88px;
  padding-bottom: 22px;
}
.content .articleInfo {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 20px;
  color: #4d4d4d;
  padding: 20px 0 75px;
}
.content .articleInfo > div:not(:last-child) {
  border-right: 1px solid #cccccc;
}
.content .articleInfo > div {
  padding: 0 15px;
  font-weight: 500;
  font-size: 20px;
  color: #4d4d4d;
}
.content .articleControl {
  font-weight: 500;
  font-size: 20px;
  color: #4d4d4d;
  text-align: left;
  font-style: normal;
  border-bottom: 1px solid #cccccc;
  padding-top: 55px;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
}
.content .articleControl > div {
  cursor: pointer;
  max-width: 48%;
  /* 超出省略号 */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/news/newsDetail.vue